/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
import BaseService from './base.service';
import { stringToDate } from '../lib/date';

export interface ITeacher {
  id: number,
  name: string,
  description: string,
  avatar: string,
  imageUrl: string,
  createdAt: Date;
}

interface ITeacherApiResponse {
  id: number,
  nome: string,
  descricao: string,
  foto: string,
  created:string;
}

export default class TeacherService extends BaseService {
  constructor() {
    super('prod/professores');
  }

  formatTeacherData(teacher:ITeacherApiResponse):ITeacher {
    return {
      id: teacher.id,
      name: teacher.nome,
      description: teacher.descricao,
      avatar: teacher.foto, // padronizar
      imageUrl: teacher.foto,
      createdAt: stringToDate(teacher.created),
    };
  }

  formatListData(teachers:ITeacherApiResponse[]):ITeacher[] {
    const teachersFormated = teachers.map((teacher) => this.formatTeacherData(teacher));
    return teachersFormated;
  }
}
